// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer__v7pGE","links":"index_links__y6ad5","copyright":"index_copyright__ekwQN"};